import { createFragmentContainer, graphql } from 'react-relay';
import styled from 'styled-components';

import createQueryRendererModern from '../../relay/createQueryRendererModern';

import drawRoutes from '../../router/utils/drawRoutes';
import { RouteType } from '../../router/utils/types';

import routeTo from '../../router/utils/routeTo';
import { getDomainName, isLoggedIn } from '../../security/authentication';
import { media } from '../../utils/style';
import HeaderLogo from '../common/header/HeaderLogo';
import _SearchForm from '../home/components/SearchForm';

import { ActionButton } from '@feedback/ui';
import { usePageView } from '@feedback/hooks';

import DomainNotFound from '../../router/middlewares/DomainNotFound';
import { useDomainName } from '../../router/middlewares/useDomainName';
import { useUnauthenticated } from '../../router/middlewares/useUnauthenticated';
import { PublicTemplate_query } from './__generated__/PublicTemplate_query.graphql';

const Wrapper = styled.div`
  flex-direction: column;
  flex: 1;
  display: flex;
`;

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 20px;
  width: 100%;

  ${media.extraSmall`
    flex-direction: column;
  `};
`;

const LinkWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  padding: 0 30px;
`;

const SearchForm = styled(_SearchForm)`
  width: 100%;
  margin: 10px;

  ${media.extraSmall`
    margin: 10px;
  `};

  ${media.medium`
    margin: 10px;
  `};
`;

type Props = {
  routes: RouteType[];
  query: PublicTemplate_query;
};
const PublicTemplate = ({ history, routes, query }: Props) => {
  const onSearch = (values) => {
    return history.push(routeTo('public.search', { search: values.search }));
  };

  const { me, company } = query;

  const isLogout = !isLoggedIn() || !me;

  const route = isLogout ? routeTo('auth.register') : routeTo('dashboard');

  usePageView();
  const validDomainName = useDomainName(company);
  useUnauthenticated(company);

  if (!validDomainName) {
    return <DomainNotFound domainName={getDomainName()} />;
  }

  return (
    <Wrapper>
      <HeaderWrapper>
        <HeaderLogo company={company} logoRoute="public" />
        <SearchForm onSubmit={onSearch} />
        <LinkWrapper>
          <ActionButton onClick={() => history.push(route)}>
            {isLogout ? 'Login/Cadastrar' : 'Meu Perfil'}
          </ActionButton>
        </LinkWrapper>
      </HeaderWrapper>
      {drawRoutes(routes)}
    </Wrapper>
  );
};

const PublicTemplateFragment = createFragmentContainer(PublicTemplate, {
  query: graphql`
    fragment PublicTemplate_query on Query {
      me {
        id
      }
      company: companyDomainName {
        ...HeaderLogo_company
        ...useDomainName_company @relay(mask: false)
        ...useUnauthenticated_company @relay(mask: false)
      }
    }
  `,
});

export default createQueryRendererModern(PublicTemplateFragment, {
  query: graphql`
    query PublicTemplateQuery {
      ...PublicTemplate_query
    }
  `,
  loadingView: null,
});
